import { ReactNode } from 'react';

import { Button, TButtonProps } from '@treezor/design-system';

export interface IPageProps {
  backAction?: Pick<TButtonProps, 'children' | 'onClick' | 'variant'> & { isInline?: boolean };
  title?: string;
  actions?: (TButtonProps & { label: string })[];
  children: ReactNode;
  tabs?: ReactNode;
}

export const Page = ({ backAction, title, actions, children }: IPageProps) => {
  const hasHeader = !!title || actions?.length > 0;
  return (
    <div className="flex flex-col flex-1 px-6 py-5 gap-5" data-testid="page">
      <div className="flex justify-between items-center" data-testid="header-page">
        <div className={`flex items-start  ${backAction?.isInline ? 'flex-row' : 'flex-col'}  gap-5`}>
          {backAction && (
            <Button
              id="back-btn"
              icon="arrow_back"
              size="s"
              variant={backAction.variant ?? 'tertiary'}
              onClick={backAction.onClick}
            >
              {backAction.children}
            </Button>
          )}
          {hasHeader && (
            <div className="flex flex-col gap-4">
              {title && <h4 className="typo-h4-bold text-secondary">{title}</h4>}
            </div>
          )}
        </div>

        <div className="flex items-center justify-start gap-3">
          {actions?.map((action, index) => (
            <Button key={`action-${index}-${action.label}`} {...action}>
              {action.label}
            </Button>
          ))}
        </div>
      </div>
      <div className="flex-grow">{children}</div>
    </div>
  );
};
